import React from 'react';
import { FMessage } from '../../hoc/IntlComponents';
import { array, bool } from 'prop-types';
import Card from '../Card/Card';
import OfferSourceList from './OfferSourceList';

const propTypes = {
  sources: array.isRequired,
  selected: array.isRequired,
  invert: bool.isRequired,
};

const defaultProps = {
  sources: [],
  selected: [],
  invert: false,
};

const OfferSources = ({ collapsing, sources, selected, invert, prefix }) => (
  <div>
    <p className="offer-sources-title">
      <FMessage id={`offer.${!invert ? 'prohibted' : 'allowed'}`} />
    </p>
    <OfferSourceList selected={selected} sources={sources} invert={invert} prefix={prefix} />
  </div>
);

OfferSources.propTypes = propTypes;
OfferSources.defaultProps = defaultProps;

export default OfferSources;
